import { media } from '@/media';
import styled from 'styled-components';

export const FilterWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const SmallCardWrapper = styled.div`
  width: 100%;
  margin-top: 40px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-row-gap: 24px;
  justify-content: space-between;

  ${media.mobile`
    display: block;
  `}
`;
